import { MutationTree, GetterTree } from 'vuex';
import { State, Section } from '@root/modules/frontpage/types/frontpage';

export const state: () => State = () => ({
  refetch: false,
  tempData: null,
});

export const getters: GetterTree<State, Record<string, unknown>> = {
  getTempData: (state) => state.tempData,
};

export const mutations: MutationTree<State> = {
  setRefetchState(state, value: boolean) {
    state.refetch = value;
  },
  setTempData(state, value: Section | null) {
    state.tempData = value;
  },
  resetTempData(state) {
    state.tempData = null;
  },
};
